import React from 'react';
import { motion } from 'motion/react';
import styles from './About.module.css';

function About() {
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
    },
  };

  return (
    <section id="about" className={styles.about}>
      <div className={styles.grid}>
        {/* Left Column — Empty placeholder for ScrollPhoto */}
        <div className={styles.photoPlaceholder} aria-hidden="true" />

        {/* Right Column — Content */}
        <motion.div
          className={styles.content}
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          <motion.p variants={itemVariants} className={styles.label}>
            About Me
          </motion.p>
          <motion.h2 variants={itemVariants} className={styles.heading}>
            Securing the connected world, from hardware to protocol.
          </motion.h2>
          <motion.p variants={itemVariants} className={styles.bio}>
            I am a B.Tech ECE student with a deep passion for securing the connected world.
            I specialize in IoT device security, firmware analysis, and wireless protocol
            exploitation — from pulling binaries off embedded hardware to breaking network
            protocols wide open.
          </motion.p>
          <motion.p variants={itemVariants} className={styles.bio}>
            When I'm not hunting vulnerabilities in embedded systems, I'm building secure
            architectures, competing in CTFs, and contributing to open-source security tools.
            I believe in offensive security as the path to better defense.
          </motion.p>
          <motion.div variants={itemVariants} className={styles.ctaWrap}>
            <a href="mailto:hello@balaram.me" className={styles.ctaButton}>
              Get in Touch
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}

export default About;
